import { render, staticRenderFns } from "./MyServices.vue?vue&type=template&id=a2abd5e6"
import script from "./MyServices.vue?vue&type=script&lang=js"
export * from "./MyServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports